var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_3343_17144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 -0.0507812C10.7402 -0.0507812 -0.0507812 10.7372 -0.0507812 24.0002C-0.0507812 37.2632 10.7402 48.0512 24.0017 48.0512C37.2632 48.0512 48.0542 37.2632 48.0542 24.0002C48.0542 10.7372 37.2632 -0.0507812 24.0017 -0.0507812ZM24.0017 46.4492C11.6237 46.4492 1.55422 36.3782 1.55422 24.0002C1.55422 11.6222 11.6237 1.55122 24.0017 1.55122C36.3797 1.55122 46.4492 11.6222 46.4492 24.0002C46.4492 36.3782 36.3797 46.4492 24.0017 46.4492Z",
    fill: "#0d5225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8346 13.5C35.7174 14.2881 34.4804 14.8908 33.1713 15.285C32.4687 14.4771 31.5349 13.9045 30.4962 13.6446C29.4575 13.3847 28.364 13.4501 27.3637 13.8319C26.3634 14.2137 25.5045 14.8935 24.9031 15.7793C24.3017 16.6652 23.9869 17.7144 24.0013 18.785V19.9517C21.951 20.0048 19.9195 19.5501 18.0875 18.628C16.2555 17.7059 14.68 16.3451 13.5013 14.6667C13.5013 14.6667 8.83464 25.1667 19.3346 29.8333C16.9319 31.4643 14.0697 32.2821 11.168 32.1667C21.668 38 34.5013 32.1667 34.5013 18.75C34.5002 18.425 34.469 18.1009 34.408 17.7817C35.5987 16.6074 36.4389 15.1248 36.8346 13.5V13.5Z",
    stroke: "#0d5225",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3343_17144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.410b368f11d4f41a4bba64cb7864b30b.svg";
export { ForwardRef as ReactComponent };